var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUspRecycling = function SvgUspRecycling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 79 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 22,
    r: 22,
    fill: "#F4F3F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.0804 14.3537C49.6499 10.8947 44.3368 8.74988 38.7466 8.16364C33.1564 7.5774 27.514 8.57333 22.4623 11.0379C17.4106 13.5025 13.1528 17.3366 10.1742 22.1034C7.1956 26.8701 5.61593 32.3777 5.61523 37.9985V44.9221",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1558 61.6496C21.587 65.1076 26.9005 67.2515 32.4908 67.8368C38.0811 68.4222 43.7234 67.4255 48.7749 64.9604C53.8264 62.4953 58.0838 58.6609 61.0622 53.894C64.0406 49.1271 65.6202 43.6194 65.6209 37.9985V31.075",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 40.3064L5.61573 44.9221L10.2315 40.3064",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2363 35.6907L65.6206 31.075L61.0049 35.6907",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2555 49.0334C29.2555 49.0334 36.0406 54.2276 41.4287 50.8981C52.3588 44.1284 44.0074 29.3058 45.5182 21.8406C41.0977 21.8421 36.7403 22.8895 32.802 24.8972C28.8637 26.9048 25.4562 29.8158 22.8581 33.3922C18.5932 39.7035 20.9933 45.5685 29.2555 49.0334Z",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8765 38.0171C33.8765 38.0171 28.1407 41.8204 27.9253 54.1537",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgUspRecycling;